'use strict';
var app = require('angular').module('directive.gridGraph', []);


app.directive('gridGraph', [require('./gridGraphDirective')]);
app.directive('simpleListGraph', [require('./simpleListGraphModal')]);
app.directive('validateHistoryGraphBis', [require('./validateHistoryGraphBisModal')]);
